const photos = [
  {
    id: 2,
    src: '/images/photos/soccer.jpeg',
    alt: 'Football Game - ETH v DCU',
    caption: 'Ethiopia vs DC United',
  },
  {
    id: 3,
    src: '/images/photos/sa1.jpeg',
    alt: 'Sitting on top of Table Mountain',
    caption: 'Sitting on Table Mountain, South Africa!',
  },
  {
    id: 4,
    src: '/images/photos/google.jpeg',
    alt: 'Google Visit',
    caption: 'First Google visit',
  },
  {
    id: 5,
    src: '/images/photos/adobe.jpeg',
    alt: 'Meeting at Adobe',
    caption: 'Lunch @ Adobe w/ Sagar Pathak',
  },
  {
    id: 34,
    src: '/images/photos/conf5.jpeg',
    alt: 'AI+ Expo 2025, Washington, DC',
    caption: 'AI+ Expo 2025, Washington, DC',
  },
  {
    id: 7,
    src: '/images/photos/robot.jpeg',
    alt: 'Submarine Circuit',
    caption: 'Wing of our submersible drone',
  },
  {
    id: 50,
    src: '/images/photos/tesla.jpeg',
    alt: 'Tesla Factories',
    caption: 'Interview @ Tesla',
  },
  {
    id: 11,
    src: '/images/photos/chrhou.jpeg',
    alt: 'Christmas Lights',
    caption: 'Loads of christmas lights',
  },
  {
    id: 12,
    src: '/images/photos/rhinos.jpeg',
    alt: 'Rhinos on safari',
    caption: 'Rhinos in Kenya!',
  },
  {
    id: 13,
    src: '/images/photos/butterflies.jpeg',
    alt: 'Butterflies on oranges',
    caption: 'Cute butterflies feasting',
  },
  {
    id: 14,
    src: '/images/photos/calforest.jpeg',
    alt: 'Redwood National Park',
    caption: 'Star Wars RP through Redwood National Park',
  },
  {
    id: 15,
    src: '/images/photos/gsw.jpeg',
    alt: 'Sitting at GSW home game',
    caption: 'Golden State Warriors!',
  },
  {
    id: 16,
    src: '/images/photos/asa.jpeg',
    alt: 'ASA Team Picture',
    caption: 'African Student Alliance Exec Team',
  },
  {
    id: 18,
    src: '/images/photos/art1.jpeg',
    alt: 'Fred and Marcia Weisman Painting',
    caption: 'Art Institute of Chicago',
  },
  {
    id: 19,
    src: '/images/photos/pier.jpeg',
    alt: 'Navy Pier Wheel',
    caption: 'Ferris Wheel @ Navy Pier',
  },
  {
    id: 35,
    src: '/images/photos/conf6.jpeg',
    alt: 'Devconnect 2025, Argentina',
    caption: 'Attendee @ Devconnect 2025, Argentina',
  },
  {
    id: 20,
    src: '/images/photos/kdot.jpeg',
    alt: 'Kendrick Lamar performing on stage',
    caption: 'Kendrick Lamar Chicago Concert',
  },
  {
    id: 21,
    src: '/images/photos/billie.jpeg',
    alt: 'Billie Eilish',
    caption: 'Billie Eilish @ Lollapalooza',
  },
  {
    id: 22,
    src: '/images/photos/arthur.jpeg',
    alt: 'Arthur Graduates',
    caption: 'Arthur Graduates from HS!',
  },
  {
    id: 23,
    src: '/images/photos/beg.jpeg',
    alt: 'Black Excellence Gala @ UR',
    caption: '1st Black Excellence Gala @ UR',
  },
  // {
  //   id: 24,
  //   src: '/images/photos/scholars.jpeg',
  //   alt: 'Richmond Scholars Hangout',
  //   caption: 'Richmond Scholars Hangout',
  // },
  {
    id: 25,
    src: '/images/photos/nightone.jpeg',
    alt: 'First Friends at UR',
    caption: 'First friends at UR!',
  },
  {
    id: 26,
    src: '/images/photos/richmond.jpeg',
    alt: 'University of Richmond Campus',
    caption: 'Boatwright Library Tower lit!',
  },
  {
    id: 29,
    src: '/images/photos/mum.jpeg',
    alt: 'RIP',
    caption: 'I love you always, mum.',
  },
  // {
  //   id: 30,
  //   src: '/images/photos/conf1.jpeg',
  //   alt: 'Bridging Academic Worlds Math Conference',
  //   caption: 'BAW Conference @ Kampala, Uganda',
  // },
  // {
  //   id: 31,
  //   src: '/images/photos/conf2.jpeg',
  //   alt: 'Pyschology Conference',
  //   caption: 'Association for Behavioral & Cognitive Therapies (ABCT) 2024, Philadelphia',
  // },
  // {
  //   id: 32,
  //   src: '/images/photos/conf3.jpeg',
  //   alt: 'A&S NEXT',
  //   caption: 'A&S NEXT @ Downtown Richmond',
  // },
  {
    id: 33,
    src: '/images/photos/conf4.jpeg',
    alt: 'Africa Tech Festival 2025, South Africa',
    caption: 'Startup Showcase @ Africa Tech Festival, South Africa',
  },
  {
    id: 8,
    src: '/images/photos/salesforce.jpeg',
    alt: 'Salesforce Cake',
    caption: 'Salesforce 25th Anniversary Celebration',
  },
  // {
  //   id: 36,
  //   src: '/images/photos/icpc.jpeg',
  //   alt: '3rd Place at Regional ICPC',
  //   caption: '3rd Place at ICPC',
  // },
  // {
  //   id: 37,
  //   src: '/images/photos/autism.jpeg',
  //   alt: 'Weekned Soccer Sessions',
  //   caption: 'Weekend Soccer for ASCV Children',
  // },  
  {
    id: 38,
    src: '/images/photos/protest.jpeg',
    alt: 'Galamsey Protesting',
    caption: 'Protesting in Accra, GH against GALAMSEY!',
  },
  {
    id: 39,
    src: '/images/photos/stillife.jpeg',
    alt: 'Still Life Charcoal Drawing',
    caption: 'Still Life Charcoal Drawing',
  },
  {
    id: 17,
    src: '/images/photos/sof.jpeg',
    alt: 'Interview for Scholars of Finance',
    caption: 'Scholars of Finance lax interview',
  },
  {
    id: 40,
    src: '/images/photos/lost.jpeg',
    alt: 'Lost Jounrey to Civilization',
    caption: 'Lost on Tracks',
  },
  {
    id: 6,
    src: '/images/photos/ra1.jpeg',
    alt: 'My first RA board',
    caption: '1st RA board - PACMAN!',
  },
  {
    id: 41,
    src: '/images/photos/arthv.jpeg',
    alt: 'Arthur Visits',
    caption: 'Arthur Visits!',
  },
  {
    id: 42,
    src: '/images/photos/florence.jpeg',
    alt: 'Florence, Italy',
    caption: 'Florence, Italy',
  },
  {
    id: 43,
    src: '/images/photos/capetown.jpeg',
    alt: 'Cape Town, South Africa',
    caption: 'Cape Town, South Africa',
  },
  {
    id: 45,
    src: '/images/photos/carbonara.jpeg',
    alt: 'My first ever succesful carbonara',
    caption: 'First succesfully made CARBONARA',
  },
  {
    id: 46,
    src: '/images/photos/giftxch.jpeg',
    alt: 'Friends Christmas Gift Exchange',
    caption: 'Secret Santa gift exchange',
  },
  {
    id: 47,
    src: '/images/photos/tutor.jpeg',
    alt: 'First Tutoring Session',
    caption: 'First robotics tutoring session was a success!',
  },
  {
    id: 48,
    src: '/images/photos/jumbotron.jpeg',
    alt: 'Mama I made it on the jumbotron',
    caption: 'Mama I made it on the jumbotron!',
  },
  {
    id: 49,
    src: '/images/photos/ben.jpeg',
    alt: 'My first and best friend, Ben',
    caption: 'Ben + Joe',
  },
  {
    id: 51,
    src: '/images/photos/r2d2.jpeg',
    alt: 'The Original R2-D2',
    caption: 'The Original R2-D2',
  },
  {
    id: 50,
    src: '/images/photos/paint1.jpeg',
    alt: 'Painting #1',
    caption: 'Thoughts on my painted collage?',
  },
  {
    id: 51,
    src: '/images/photos/paint2.jpeg',
    alt: 'Painting #2',
    caption: 'An experiment of independent continuity',
  },
  {
    id: 52,
    src: '/images/photos/galam2.jpeg',
    alt: 'Community Meeting at Abuakwa',
    caption: 'Galamsey Talk @ Abuakwa',
  },
  {
    id: 27,
    src: '/images/photos/engineer.jpeg',
    alt: 'Engineering @ KNUST',
    caption: 'Shout out all my friends who snuck me into their classes!',
  },
  {
    id: 1,
    src: '/images/photos/fam.jpeg',
    alt: 'Image of the Lobowicz brothers',
    caption: 'Ignore Adolf\'s frown lol',
  },
];

export default photos;
